<template>
  <div class="admin-dashboard">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb :items="[$t('menu.dashboard')]" />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
          <admin-organization-switcher/>
      </el-col>
    </el-row>
    <start-learning v-if="!isAdmin && !isTeacher && !isStudent" />
    <admins-dashboard v-if="isAdmin" />
    <students-dashboard v-if="isStudent" />
    <teachers-dashboard v-if="isTeacher && !isAdmin" />
  </div>
</template>

<script>
  import StartLearning from "@/views/StartLearning";
  import AdminsDashboard from "@/components/dashboard/AdminsDashboard";
  import StudentsDashboard from "@/components/dashboard/StudentsDashboard";
  import TeachersDashboard from "@/components/dashboard/TeachersDashboard";
  import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
  import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
  import { mapGetters, mapState } from "vuex";
  import { ADMIN, TEACHER, STUDENT } from "../constants/userRoles";

  export default {
    components: {
      AdminsDashboard,
      StudentsDashboard,
      TeachersDashboard,
      StartLearning,
      OrganizationBreadcrumb,
      AdminOrganizationSwitcher
    },
    props: ["organizationId"],
    computed: {
      isAdmin() {
        return this.isOrganizationAdmin || this.isOrganizationAssociateAdmin;
      },
      isStudent() {
        return (
          !this.userHasOrganizationRole(ADMIN) &&
          !this.userHasOrganizationRole(TEACHER) &&
          this.userHasOrganizationRole(STUDENT)
        );
      },
      isTeacher() {
        return this.userHasOrganizationRole(TEACHER);
      },
      ...mapState("user", ["isFirstLogin", "isElsaAdmin"]),
      ...mapGetters("organization", [
        "userHasOrganizationRole", 
        "isOrganizationAdmin", 
        "isOrganizationAssociateAdmin", 
        "isGeneralAdmin",
        "hasChildOrg",
        "hasFilter",
        ]),
    },
  };
</script>

<style lang="scss" scoped>
  .admin-dashboard {
    width: 100%;
  }
</style>
